import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { getItem, setItem } from "utils/localStorage"

interface IDashboardSettingState {
 dashboardSetting: IDashboardState
}
interface IDashboardState {
 isDraggable: boolean
 isEditable: boolean

 items: Array<{
  id: string
  name: string
  type: string
  size: string
  selectedDeviceId: number[]
 }>
}

const initialState: IDashboardSettingState = {
 dashboardSetting: getItem("dashboardSetting") || {
  isDraggable: true,
  isEditable: false,
  items: [],
 },
}

export const getDashboardSelectedIds = createSlice({
 name: "dashboardDevicesIds",
 initialState,
 reducers: {
  setDashboardDeviceIds: (state, action: PayloadAction<IDashboardState>) => {
   const { isDraggable,  isEditable, items } = action.payload
   setItem("dashboardSetting", action.payload)
   // Preserve previous data by updating individual properties
   state.dashboardSetting.isDraggable = isDraggable
   state.dashboardSetting.isEditable = isEditable
  

   // Concatenate previous and new items arrays
   state.dashboardSetting.items = items

   // Store state in localStorage if needed
   // setItem("dashboardState", state);
  }
 },
})

export const { setDashboardDeviceIds } = getDashboardSelectedIds.actions
export default getDashboardSelectedIds.reducer
